import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M4.16667 3.33332H3.33333C2.8731 3.33332 2.5 2.96023 2.5 2.49999C2.5 2.03975 2.8731 1.66666 3.33333 1.66666H16.6667C17.1269 1.66666 17.5 2.03975 17.5 2.49999C17.5 2.96023 17.1269 3.33332 16.6667 3.33332H15.8333V5.77468C15.8333 6.61057 15.4156 7.39115 14.7201 7.85481L11.5023 9.99999L14.7201 12.1452C15.4156 12.6088 15.8333 13.3894 15.8333 14.2253V16.6667H16.6667C17.1269 16.6667 17.5 17.0398 17.5 17.5C17.5 17.9602 17.1269 18.3333 16.6667 18.3333H3.33333C2.8731 18.3333 2.5 17.9602 2.5 17.5C2.5 17.0398 2.8731 16.6667 3.33333 16.6667H4.16667V14.2253C4.16667 13.3894 4.58442 12.6088 5.27992 12.1452L8.49769 9.99999L5.27992 7.85481C4.58442 7.39115 4.16667 6.61057 4.16667 5.77468V3.33332ZM5.83333 3.33332V5.77468C5.83333 5.79433 5.83403 5.81389 5.83539 5.83332H14.1646C14.166 5.81389 14.1667 5.79433 14.1667 5.77468V3.33332H5.83333ZM14.1667 15V14.2253C14.1667 13.9467 14.0274 13.6865 13.7956 13.5319L10 11.0015L6.20442 13.5319C5.97258 13.6865 5.83333 13.9467 5.83333 14.2253V15H14.1667Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }